export default __webpack_public_path__ + "static/media/license-info-premium.9148dc90.png";